import {
  Mesh,
  MeshBasicMaterial,
  SphereGeometry,
} from 'three'
import SceneVisualBase from './SceneVisualObjectBase'

import {
  tablePush,
  tablePop
} from './tableListeners';
const pointsColor = 0xfeff00;
const pointRadius = 0.3;
const sphereGeometry = new SphereGeometry(pointRadius, 16, 16);

const pointsHighlightColor = 0xff0000

export default class UserFigure extends SceneVisualBase {
  constructor(camera, draw, tooltipLine) {
    super(camera)
    this.tooltipLine = tooltipLine,
      this.points = [],
      this.lines = [],
      this.userPoints = [],
      this.pointsSize = 1,
      this.draw = draw

    this.pointDefaultMaterial = new MeshBasicMaterial({
      color: pointsColor,
    });
    this.pointHighlightedMaterial = new MeshBasicMaterial({
      color: pointsHighlightColor,
    });
  }

  setStartPoint(pos) {
    this.startPoint = pos
  }

  addPoint(pos, steelMode) {
    let duplicatePoint = this.points.find(point => point.equals(pos))
    if (!duplicatePoint) {
      let userPoint = new Mesh(sphereGeometry, this.pointDefaultMaterial)
      userPoint.scale.setScalar(this.pointsSize)
      userPoint.userData.isUserPoint = true;
      userPoint.position.copy(pos)
      this.userPoints.push(userPoint)
      this.add(userPoint)
    }

    if (this.points.length > 0) {
      let start = this.getStartPoint()
      let end = pos
      if (start && start.distanceTo(end) > 0) {
        let line = this.draw.drawLine(start, end, 'draw', steelMode)
        this.add(line.userData.steel)
        this.add(line.userData.steelFaces)
        tablePush(line.userData.length)
        this.lines.push(line)
        this.tooltipLine.lineLabel.visible = true;
        this.tooltipLine.setNewlineLabelPosition(line.userData.steelFaces.position, this.lines[this.lines.length - 1].userData.length)
        this.add(line)
      }
    }

    if (!duplicatePoint) {
      this.points.push(pos)
    } 
    this.startPoint = pos
  }

  setPointHighlight(pointMesh, highlighted) {
    if (pointMesh.parent !== this) {
      console.error('not this group parent')
      return
    }
    if (highlighted) {
      pointMesh.material = this.pointHighlightedMaterial
    } else {
      pointMesh.material = this.pointDefaultMaterial
    }
  }

  getStartPoint() {
    return this.startPoint
  }

  raycastPoint(mouse) {
    return this.raycaster.getObjects(mouse, this.userPoints)
  }

  setPointsSize(size) {
    this.pointsSize = size
    this.userPoints.forEach(i => {
      i.scale.setScalar(size)
    })
  }

  changeViewMode(steelMode) {
    if (steelMode === 'onlyCenterLines') {
      this.lines.forEach(line => {
        line.userData.steelFaces.material.visible = false;
        line.userData.steel.material.visible = false
      })
    } else if (steelMode === 'halfSteelVisible') {
      this.lines.forEach(line => {
        line.userData.steelFaces.material.visible = true;
        line.userData.steelFaces.material.opacity = 0.5
        line.userData.steel.material.visible = true
      })
    } else if (steelMode === 'fullVisible') {
      this.lines.forEach(line => {
        line.userData.steelFaces.material.opacity = 1;
      })
    }
  }

  undoFunction() {
    if(this.userPoints.length == 1){
      this.removeUserPoints()
    }else if (this.userPoints.length) {
      this.deleteLine()
      tablePop()
    }
    return this.startPoint
  }

  deleteLine() {
    let lastLine = this.lines.pop()
    let lineProps = lastLine.userData
    delete lineProps.length
    for (let key in lineProps) {
      this.remove(lineProps[key])
      lineProps[key].material.dispose()
      lineProps[key].geometry.dispose()
    }
    this.remove(lastLine)

    if (this.lines.length > 1) {
      this.tooltipLine.lineLabel.visible = true;
      let newPosAndText = this.lines[this.lines.length - 1].userData
      this.tooltipLine.setNewlineLabelPosition(newPosAndText.steelFaces.position, newPosAndText.length)
    } else {
      this.tooltipLine.lineLabel.visible = false;
    }
        let lastPoint = this.userPoints[this.userPoints.length - 1].position
    let equ = this.lines.some(line => {
      let vertice = line.geometry.vertices
      return vertice[0].equals(lastPoint) || vertice[1].equals(lastPoint)
    })
    if(!equ) this.removeUserPoints()
  }

  removeUserPoints() {
    let lastPoint = this.userPoints.pop()
    this.points = this.points.filter( value => !value.equals(lastPoint.position));
    this.remove(lastPoint)
    lastPoint.material.dispose()
    lastPoint.geometry.dispose()
    if(this.userPoints.length){
    this.setStartPoint(this.userPoints[this.userPoints.length - 1].position)
    } else {
      this.setStartPoint(null)
    }
  }
}